import axios from 'axios'
// import CryptoJS from 'crypto-js';
import { onWindowOpen } from './onWindowOpen'

export const onTokenValid = ({ idauth, token }, dataRESP, stateHelper, stateDiss, setstateHelper, setstateDiss) => {
  setstateDiss({ ...stateDiss, dtk: true, loggin: true })
  const Url = 'https://token.saamqx.net:4700/verify?'
  // Encrypt
  // const ciphertext = CryptoJS.AES.encrypt(`${idauth}opop${token}`, 'CodeFORWARDHypercrit').toString();

  return axios
    .get(`${Url}code=${idauth}opop${token}`)
    .then(({ data }) => {
      const { err, message } = data
      if (!err) {
        if (message === 'Ok') {
          setstateHelper({ ...stateHelper, dip: false, tiu: '', tpw: '', ttk: '', etk: false, epw: false, eiu: false })
          setstateDiss({ ...stateDiss, diu: false, dpw: false, dtk: false, loggin: false })
          onWindowOpen(dataRESP, `&data=????`)
          return true
        } else {
          return onHaldlenStatus(stateHelper, stateDiss, setstateHelper, setstateDiss, message)
        }
      } else {
        const { message } = data
        return onHaldlenStatus(stateHelper, stateDiss, setstateHelper, setstateDiss, message)
      }
    })
    .catch(() => {
      return onHaldlenStatus(
        stateHelper,
        stateDiss,
        setstateHelper,
        setstateDiss,
        'Error en validar! Intente de Nuevo!'
      )
    })
}

const onHaldlenStatus = (stateHelper, stateDiss, setstateHelper, setstateDiss, message) => {
  setstateHelper({ ...stateHelper, etk: true, ttk: message })
  setstateDiss({ ...stateDiss, dtk: false, loggin: false })
  return false
}
